import { deepEqual } from 'fast-equals';
import { useEffect, useRef } from 'react';

function useMemoDeep(value: any) {
    const ref = useRef();

    if (!deepEqual(value, ref.current)) {
        ref.current = value;
    }

    return ref.current;
}

export function useEffectDeep(
    callback: React.EffectCallback,
    dependencies: any[]
) {
    useEffect(callback, dependencies.map(useMemoDeep));
}
